import { useInvoices } from '@klear/ui/hooks/use-invoices'
import { Card } from '@klear/ui/components/card'
import { Button } from '@klear/ui/components/button'
import { Skeleton } from '@klear/ui/components/skeleton'
import type { WizardStepComponentProps } from '@klear/ui/wizard/flow'
import type { ReceivableStepCtx } from '@/app/receivable/workflow/ReceivableWizardContext'

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <span className="font-medium text-muted-foreground">{label}</span>
      <p className="text-foreground">{value || '—'}</p>
    </div>
  )
}

export default function ReviewStep({ ctx }: WizardStepComponentProps<ReceivableStepCtx>) {
  const { form, proofAdded, handleDone } = ctx
  const invoiceEventId = form.invoiceEventId
  const { invoices, isLoading } = useInvoices(invoiceEventId != null ? { orderEventId: [invoiceEventId] } : undefined, {
    enabled: invoiceEventId != null
  })
  const invoice = invoices[0]

  if (invoiceEventId == null) {
    return <div className="text-sm text-muted-foreground">Create the invoice first.</div>
  }

  if (isLoading && !invoice) {
    return (
      <div className="space-y-4 w-full max-w-2xl">
        <Skeleton className="h-40 w-full" />
      </div>
    )
  }

  return (
    <div className="space-y-6 w-full max-w-2xl">
      <Card className="p-6 space-y-4">
        <h2 className="text-lg font-semibold text-foreground">Invoice</h2>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <Row label="Invoice" value={invoice?.idDisplay ?? '—'} />
          <Row label="Customer" value={invoice?.customerName ?? '—'} />
          <Row label="Amount" value={invoice?.amount.toString() ?? '—'} />
          <Row label="Status" value={invoice?.status ?? '—'} />
          <Row label="Invoice Date" value={invoice?.effectiveDate.toString() ?? '—'} />
          <Row label="Due Date" value={invoice?.endDate.toString() ?? '—'} />
        </div>
        <div className="border-t pt-3 text-sm">
          <Row label="Proof of acceptance" value={proofAdded ? 'Added' : 'Not added (optional)'} />
        </div>
      </Card>

      <div className="flex justify-end">
        <Button onClick={handleDone}>Done</Button>
      </div>
    </div>
  )
}
